(() => {
const initFilters = () => {
  if (window.Eurus.filtersInitialized) return;
  window.Eurus.filtersInitialized = true;
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: {},
    requestId: 0,
    requestController: null,
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      this.onHistoryChange = onHistoryChange;
      window.addEventListener('popstate', this.onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);
    },
    destroy() {
      clearTimeout(this.t);
      this.requestId += 1;
      this.requestController?.abort();
      window.removeEventListener('popstate', this.onHistoryChange);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    async renderPagination() {
      if (this.loading) return;
      this.loading = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      try {
      const response = await fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      });
        if (!response.ok) throw new Error(`Page size HTTP ${response.status}`);
        this.cachedResults = {};
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        await this._renderPage(searchParams);
      } catch (error) {
        this._showError(this.searchParamsPrev);
      } finally {
        clearTimeout(timeout);
        this.loading = false;
      }
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);;
          
          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    async _renderPage(searchParams, updateURLHash = true) {
      const requestId = ++this.requestId;
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      this.loading = true;
      this._clearError();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        let html = this.cachedResults[searchParams];
        if (!html) {
          const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&${searchParams}`;
          const response = await fetch(url, {signal: controller.signal});
          if (!response.ok) throw new Error(`Filters HTTP ${response.status}`);
          html = await response.text();
        }
        if (requestId !== this.requestId) return false;
        this._renderResults(html);
        this.cachedResults[searchParams] = html;
        this.searchParamsPrev = searchParams;
        if (updateURLHash) this._updateURLHash(searchParams);
        return true;
      } catch (error) {
        if (requestId === this.requestId) this._showError(searchParams);
        return false;
      } finally {
        clearTimeout(timeout);
        if (requestId === this.requestId) {
          this.loading = false;
          this.requestController = null;
        }
      }
    },
    _clearError() {
      document.getElementById(`filter-error-${sectionId}`)?.remove();
    },
    _showError(searchParams) {
      this._clearError();
      const grid = document.getElementById('ProductGridContainer');
      if (!grid) return;
      const message = document.createElement('p');
      message.id = `filter-error-${sectionId}`;
      message.setAttribute('role', 'alert');
      message.className = 'p-4';
      const italian = document.documentElement.lang.startsWith('it');
      message.append(document.createTextNode(italian
        ? 'Impossibile aggiornare i risultati. Sono mostrati i risultati precedenti. '
        : 'Could not update results. The previous results are still shown. '));
      const retry = document.createElement('a');
      retry.href = `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`;
      retry.textContent = italian ? 'Riprova' : 'Try again';
      retry.className = 'underline';
      message.appendChild(retry);
      grid.before(message);
    },
    _renderResults(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      // Validate before changing any live results or controls.
      for (const selector of ['#ProductGridContainer', '.form-drawer', '.form-aside', '#active-filter-tag', '#ProductPerPage']) {
        if (document.querySelector(selector) && !parsedHTML.querySelector(selector)) {
          throw new Error(`Missing filter section: ${selector}`);
        }
      }
      if (!parsedHTML.getElementById('ProductGridContainer')) throw new Error('Missing product results');
      this._renderFilters(parsedHTML);
      this._renderProductGridContainer(parsedHTML);
      this._renderProductCount(parsedHTML);
    },
    _renderFilters(parsedHTML) {
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      let activeTag = document.getElementById("active-filter-tag")

      if (activeTag) {
        activeTag.innerHTML = parsedHTML.getElementById("active-filter-tag").innerHTML;   
      }
      if (selectBlockFiltesDrawer) {
        if (this.$el.id) {  
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesDrawer.innerHTML = parsedHTML.querySelector(blockFiltesDrawer).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesAside.innerHTML = parsedHTML.querySelector(blockFiltesAside).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          if (source[index]) destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = html.getElementById('ProductGridContainer').innerHTML;
    },
    _renderProductCount(html) {
      const productCountEl = html.getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
        container?.classList.remove('loading');
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      const elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
};
if (window.Alpine) initFilters();
else document.addEventListener('alpine:init', initFilters, {once: true});
})();
